import React from 'react';
import type { SVGProps } from 'react';
import { Home } from 'pixelarticons/react/Home.js';
import { Note } from 'pixelarticons/react/Note.js';
import { MapPin } from 'pixelarticons/react/MapPin.js';
import { Mail } from 'pixelarticons/react/Mail.js';
import { Lock } from 'pixelarticons/react/Lock.js';
import { Login } from 'pixelarticons/react/Login.js';
import { Message } from 'pixelarticons/react/Message.js';
import { GitBranch } from 'pixelarticons/react/GitBranch.js';
import { Megaphone } from 'pixelarticons/react/Megaphone.js';
import { Bug } from 'pixelarticons/react/Bug.js';
import { Lightbulb } from 'pixelarticons/react/Lightbulb.js';
import { Hand } from 'pixelarticons/react/Hand.js';
import { Briefcase } from 'pixelarticons/react/Briefcase.js';
import { Smartphone } from 'pixelarticons/react/Smartphone.js';
import { CreditCard } from 'pixelarticons/react/CreditCard.js';
import { Wallet } from 'pixelarticons/react/Wallet.js';
import { Calendar } from 'pixelarticons/react/Calendar.js';
import { Factory } from 'pixelarticons/react/Factory.js';
import { BookOpen } from 'pixelarticons/react/BookOpen.js';
import { Users } from 'pixelarticons/react/Users.js';
import { BuildingCommunity } from 'pixelarticons/react/BuildingCommunity.js';
import { Teach } from 'pixelarticons/react/Teach.js';
import { Store } from 'pixelarticons/react/Store.js';
import { Clock } from 'pixelarticons/react/Clock.js';
import { Trophy } from 'pixelarticons/react/Trophy.js';
import { Coins } from 'pixelarticons/react/Coins.js';
import { Check } from 'pixelarticons/react/Check.js';
import { ArrowRight } from 'pixelarticons/react/ArrowRight.js';
import { ArrowLeft } from 'pixelarticons/react/ArrowLeft.js';
import { ArrowDown } from 'pixelarticons/react/ArrowDown.js';
import { Human } from 'pixelarticons/react/Human.js';
import { Shield } from 'pixelarticons/react/Shield.js';
import { Script } from 'pixelarticons/react/Script.js';
import { Search } from 'pixelarticons/react/Search.js';
import { Pencil } from 'pixelarticons/react/Pencil.js';
import { Sofa } from 'pixelarticons/react/Sofa.js';
import { Logout } from 'pixelarticons/react/Logout.js';
import { Clipboard } from 'pixelarticons/react/Clipboard.js';
import { ToolCase } from 'pixelarticons/react/ToolCase.js';
import { Plus } from 'pixelarticons/react/Plus.js';
import { Minus } from 'pixelarticons/react/Minus.js';
import { Target } from 'pixelarticons/react/Target.js';
import { ZoomIn } from 'pixelarticons/react/ZoomIn.js';
import { ZoomOut } from 'pixelarticons/react/ZoomOut.js';
import { Grid3x3 } from 'pixelarticons/react/Grid3x3.js';
import { AvatarSquare } from 'pixelarticons/react/AvatarSquare.js';
import { Chart } from 'pixelarticons/react/Chart.js';
import { Flag } from 'pixelarticons/react/Flag.js';
import { UserX } from 'pixelarticons/react/UserX.js';
import { Image } from 'pixelarticons/react/Image.js';
import { Laugh } from 'pixelarticons/react/Laugh.js';
import { Music } from 'pixelarticons/react/Music.js';
import { Eye } from 'pixelarticons/react/Eye.js';
import { SettingsCog2 } from 'pixelarticons/react/SettingsCog2.js';
import { Close } from 'pixelarticons/react/Close.js';
import { Save } from 'pixelarticons/react/Save.js';
import { CursorMinimal } from 'pixelarticons/react/CursorMinimal.js';
import { Pointer } from 'pixelarticons/react/Pointer.js';
import { Ratio } from 'pixelarticons/react/Ratio.js';
import { Wall } from 'pixelarticons/react/Wall.js';
import { DoorClosed } from 'pixelarticons/react/DoorClosed.js';
import { CornerRightUp } from 'pixelarticons/react/CornerRightUp.js';
import { WindowFrame } from 'pixelarticons/react/WindowFrame.js';
import { Trash } from 'pixelarticons/react/Trash.js';
import { Reload } from 'pixelarticons/react/Reload.js';
import { Scissors } from 'pixelarticons/react/Scissors.js';
import { Pipette } from 'pixelarticons/react/Pipette.js';
import { Shirt } from 'pixelarticons/react/Shirt.js';
import { Crown } from 'pixelarticons/react/Crown.js';
import { DiamondGem } from 'pixelarticons/react/DiamondGem.js';
import { Sunglasses } from 'pixelarticons/react/Sunglasses.js';
import { Handbag } from 'pixelarticons/react/Handbag.js';
import { Mic } from 'pixelarticons/react/Mic.js';
import { CellularSignal0 } from 'pixelarticons/react/CellularSignal0.js';
import { CellularSignal1 } from 'pixelarticons/react/CellularSignal1.js';
import { CellularSignal2 } from 'pixelarticons/react/CellularSignal2.js';
import { CellularSignal3 } from 'pixelarticons/react/CellularSignal3.js';
import { MicOff } from 'pixelarticons/react/MicOff.js';
import { Monitor } from 'pixelarticons/react/Monitor.js';
import { Heart } from 'pixelarticons/react/Heart.js';
import { Volume2 } from 'pixelarticons/react/Volume2.js';
import { WarningDiamond } from 'pixelarticons/react/WarningDiamond.js';
import { SquareAlert } from 'pixelarticons/react/SquareAlert.js';
import { InfoBox } from 'pixelarticons/react/InfoBox.js';

/**
 * Pants / Shoes — sem equivalente em pixelarticons; desenhados à mão no
 * mesmo grid de blocos 24×24 / fill currentColor das demais peças
 * (ver node_modules/pixelarticons/svg/shirt.svg como referência de estilo).
 */
const Pants: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M6 3h12v2H6zM5 5h14v6H5z" />
    <path d="M5 11h6v10H8l-1-8-1 8H5zM13 11h6v10h-3l-1-8-1 8h-1z" />
  </svg>
);

const Shoes: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M6 4h6v7h-6z" />
    <path d="M6 11h5l4 3h6v3H6z" />
    <path d="M4 17h18v3H4z" />
  </svg>
);

/**
 * Leaf — sem equivalente em pixelarticons; folha em blocos de 2px no mesmo
 * grid 24x24 / fill=currentColor (título "Guardião do Jardim" no HUD, 021).
 * Gota diagonal (ponta no canto superior direito, caule no inferior esquerdo)
 * mais um traço de nervura central.
 */
const Leaf: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M14 4h2v2h-2zM12 6h2v2h-2zM10 8h4v2h-4zM8 10h6v2H8zM6 12h6v2H6zM6 14h4v2H6zM6 16h2v2H6zM18 6h2v6h-2zM18 12h-6v-2h6z" />
  </svg>
);

/** Volume2 existe; o “mudo” (X no alto-falante) não — mesmo grid 24×24. */
const VolumeOff: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M13 2h2v20h-2v-2h-2v-2h2V6h-2V4h2V2Zm-4 6v2H7v4h2v2H5V8h4Zm2 0h-2V6h2v2Zm2 10h-2v-2h2v2Z" />
    <path d="M4 4h2v2H4zm2 2h2v2H6zM8 8h2v2H8zm2 2h2v2h-2zm2 2h2v2h-2zm2 2h2v2h-2zm2 2h2v2h-2zm2 2h2v2h-2zM2 2h2v2H2z" />
  </svg>
);

const ICONS = {
  home: Home,
  note: Note,
  map: MapPin,
  mail: Mail,
  lock: Lock,
  login: Login,
  message: Message,
  gitBranch: GitBranch,
  megaphone: Megaphone,
  bug: Bug,
  lightbulb: Lightbulb,
  hand: Hand,
  briefcase: Briefcase,
  smartphone: Smartphone,
  creditCard: CreditCard,
  wallet: Wallet,
  calendar: Calendar,
  factory: Factory,
  bookOpen: BookOpen,
  users: Users,
  buildingCommunity: BuildingCommunity,
  teach: Teach,
  store: Store,
  clock: Clock,
  trophy: Trophy,
  coins: Coins,
  check: Check,
  arrowRight: ArrowRight,
  arrowLeft: ArrowLeft,
  arrowDown: ArrowDown,
  human: Human,
  shield: Shield,
  script: Script,
  search: Search,
  pencil: Pencil,
  sofa: Sofa,
  logout: Logout,
  clipboard: Clipboard,
  toolCase: ToolCase,
  plus: Plus,
  minus: Minus,
  target: Target,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
  grid: Grid3x3,
  avatar: AvatarSquare,
  chart: Chart,
  flag: Flag,
  userX: UserX,
  image: Image,
  laugh: Laugh,
  music: Music,
  eye: Eye,
  /** SettingsCog2, não SettingsCog: o build React do SettingsCog inclui um path de fundo
   * 24x24 com fill=currentColor (resíduo do clipPath do SVG original), que pinta um bloco
   * sólido atrás da engrenagem. SettingsCog2 não tem esse path espúrio. */
  settings: SettingsCog2,
  close: Close,
  save: Save,
  /** Cursores de sala (mesmo set usado no canvas Pixen). */
  cursorMinimal: CursorMinimal,
  pointer: Pointer,
  /** Editor de sala. */
  ratio: Ratio,
  wall: Wall,
  door: DoorClosed,
  stairs: CornerRightUp,
  windows: WindowFrame,
  trash: Trash,
  reload: Reload,
  /** Editor de avatar — classificações de peças. */
  scissors: Scissors,
  pipette: Pipette,
  shirt: Shirt,
  pants: Pants,
  shoes: Shoes,
  crown: Crown,
  diamondGem: DiamondGem,
  sunglasses: Sunglasses,
  handbag: Handbag,
  /** Comunicação por proximidade (020). */
  mic: Mic,
  micOff: MicOff,
  volume: Volume2,
  volumeOff: VolumeOff,
  monitor: Monitor,
  windowFrame: WindowFrame,
  signal0: CellularSignal0,
  signal1: CellularSignal1,
  signal2: CellularSignal2,
  signal3: CellularSignal3,
  /** Gestos sociais (menu ao lado do envio de chat) — "mandar beijo". */
  heart: Heart,
  /** Chip "Você" do HUD — título de progressão (Life Garden, 021). */
  leaf: Leaf,
  /** Toasts globais — sucesso reaproveita `check`. */
  warning: WarningDiamond,
  alert: SquareAlert,
  info: InfoBox,
} as const;

export type PixelIconName = keyof typeof ICONS;

export type PixelIconProps = {
  name: PixelIconName;
  size?: number;
  className?: string;
} & Omit<SVGProps<SVGSVGElement>, 'ref' | 'width' | 'height'>;

/** Ícones pixel 24×24 (pixelarticons). Preferir sizes múltiplos de 24. */
export const PixelIcon: React.FC<PixelIconProps> = ({
  name,
  size = 24,
  className,
  'aria-hidden': ariaHidden = true,
  ...rest
}) => {
  const Icon = ICONS[name];

  const mergedClass = className ? `lp-pixel-icon ${className}` : 'lp-pixel-icon';

  return (
    <Icon
      width={size}
      height={size}
      className={mergedClass}
      aria-hidden={ariaHidden}
      {...rest}
    />
  );
};
